import { render, staticRenderFns } from "./StoreStaff.vue?vue&type=template&id=1ecf7a5e&"
import script from "./StoreStaff.vue?vue&type=script&lang=js&"
export * from "./StoreStaff.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports